import apis from '@/apis/coreIAM/apis'
import { apisTypes } from '@/store/mutationTypes'

export default {
    state: {
        getDefaultScopes: {
            pending: false,
            error: null,
        },
        addDefaultScope: {
            pending: false,
            error: null,
        },
        removeDefaultScope: {
            pending: false,
            error: null,
        },
        getOptionalScopes: {
            pending: false,
            error: null,
        },
        addOptionalScope: {
            pending: false,
            error: null,
        },
        removeOptionalScope: {
            pending: false,
            error: null,
        }
    },
    mutations: {
        [apisTypes.FETCH_ALL_DEFAULT_SCOPES_REQUEST]: function (state) {
            state.getDefaultScopes.pending = true;
        },
        [apisTypes.FETCH_ALL_DEFAULT_SCOPES_SUCCESS]: function (state) {
            state.getDefaultScopes.error = null;
            state.getDefaultScopes.pending = false;
        },
        [apisTypes.FETCH_ALL_DEFAULT_SCOPES_FAILURE]: function (state, error) {
            state.getDefaultScopes.error = error;
            state.getDefaultScopes.pending = false;
        },
        [apisTypes.ADD_DEFAULT_SCOPE_REQUEST]: function (state) {
            state.addDefaultScope.pending = true;
        },
        [apisTypes.ADD_DEFAULT_SCOPE_SUCCESS]: function (state) {
            state.addDefaultScope.error = null;
            state.addDefaultScope.pending = false;
        },
        [apisTypes.ADD_DEFAULT_SCOPE_FAILURE]: function (state, error) {
            state.addDefaultScope.error = error;
            state.addDefaultScope.pending = false;
        },
        [apisTypes.REMOVE_DEFAULT_SCOPE_REQUEST]: function (state) {
            state.removeDefaultScope.pending = true;
        },
        [apisTypes.REMOVE_DEFAULT_SCOPE_SUCCESS]: function (state) {
            state.removeDefaultScope.error = null;
            state.removeDefaultScope.pending = false;
        },
        [apisTypes.REMOVE_DEFAULT_SCOPE_FAILURE]: function (state, error) {
            state.removeDefaultScope.error = error;
            state.removeDefaultScope.pending = false;
        },
        [apisTypes.FETCH_ALL_OPTIONAL_SCOPES_REQUEST]: function (state) {
            state.getOptionalScopes.pending = true;
        },
        [apisTypes.FETCH_ALL_OPTIONAL_SCOPES_SUCCESS]: function (state) {
            state.getOptionalScopes.error = null;
            state.getOptionalScopes.pending = false;
        },
        [apisTypes.FETCH_ALL_OPTIONAL_SCOPES_FAILURE]: function (state, error) {
            state.getOptionalScopes.error = error;
            state.getOptionalScopes.pending = false;
        },
        [apisTypes.ADD_OPTIONAL_SCOPE_REQUEST]: function (state) {
            state.addOptionalScope.pending = true;
        },
        [apisTypes.ADD_OPTIONAL_SCOPE_SUCCESS]: function (state) {
            state.addOptionalScope.error = null;
            state.addOptionalScope.pending = false;
        },
        [apisTypes.ADD_OPTIONAL_SCOPE_FAILURE]: function (state, error) {
            state.addOptionalScope.error = error;
            state.addOptionalScope.pending = false;
        },
        [apisTypes.REMOVE_OPTIONAL_SCOPE_REQUEST]: function (state) {
            state.removeOptionalScope.pending = true;
        },
        [apisTypes.REMOVE_OPTIONAL_SCOPE_SUCCESS]: function (state) {
            state.removeOptionalScope.error = null;
            state.removeOptionalScope.pending = false;
        },
        [apisTypes.REMOVE_OPTIONAL_SCOPE_FAILURE]: function (state, error) {
            state.removeOptionalScope.error = error;
            state.removeOptionalScope.pending = false;
        },
    },
    actions: {
        async getDefaultScopes({ commit }, payload) {
            commit(apisTypes.FETCH_ALL_DEFAULT_SCOPES_SUCCESS)
            return new Promise((resolve, reject) => {
                apis
                    .getDefaultScopes(
                        payload.uuid,
                    )
                    .then((roles) => {
                        commit(apisTypes.FETCH_ALL_DEFAULT_SCOPES_SUCCESS)
                        resolve(roles.data)
                    })
                    .catch((error) => {
                        commit(apisTypes.FETCH_ALL_DEFAULT_SCOPES_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async addDefaultScope({ commit }, payload) {
            commit(apisTypes.ADD_DEFAULT_SCOPE_REQUEST)
            return new Promise((resolve, reject) => {
                apis.addDefaultScope(payload.uuid, payload.scopeUuid).then(() => {
                    commit(apisTypes.ADD_DEFAULT_SCOPE_SUCCESS)
                    resolve()
                }).catch((error) => {
                    commit(apisTypes.ADD_DEFAULT_SCOPE_FAILURE, error)
                    reject(error)
                })
            })
        },
        async removeDefaultScope({ commit }, payload) {
            commit(apisTypes.REMOVE_DEFAULT_SCOPE_REQUEST)
            return new Promise((resolve, reject) => {
                apis.removeDefaultScope(payload.uuid, payload.scopeUuid).then(() => {
                    commit(apisTypes.REMOVE_DEFAULT_SCOPE_SUCCESS)
                    resolve()
                }).catch((error) => {
                    commit(apisTypes.REMOVE_DEFAULT_SCOPE_FAILURE, error)
                    reject(error)
                })
            })
        },
        async getOptionalScopes({ commit }, payload) {
            commit(apisTypes.FETCH_ALL_OPTIONAL_SCOPES_REQUEST)
            return new Promise((resolve, reject) => {
                apis
                    .getOptionalScopes(
                        payload.uuid,
                    )
                    .then((roles) => {
                        commit(apisTypes.FETCH_ALL_OPTIONAL_SCOPES_SUCCESS)
                        resolve(roles.data)
                    })
                    .catch((error) => {
                        commit(apisTypes.FETCH_ALL_OPTIONAL_SCOPES_FAILURE, error)
                        reject(error)
                    })
            })
        },
        async addOptionalScope({ commit }, payload) {
            commit(apisTypes.ADD_OPTIONAL_SCOPE_REQUEST)
            return new Promise((resolve, reject) => {
                apis.addOptionalScope(payload.uuid, payload.scopeUuid).then(() => {
                    commit(apisTypes.ADD_OPTIONAL_SCOPE_SUCCESS)
                    resolve()
                }).catch((error) => {
                    commit(apisTypes.ADD_OPTIONAL_SCOPE_FAILURE, error)
                    reject(error)
                })
            })
        },
        async removeOptionalScope({ commit }, payload) {
            commit(apisTypes.REMOVE_OPTIONAL_SCOPE_REQUEST)
            return new Promise((resolve, reject) => {
                apis.removeOptionalScope(payload.uuid, payload.scopeUuid).then(() => {
                    commit(apisTypes.REMOVE_OPTIONAL_SCOPE_SUCCESS)
                    resolve()
                }).catch((error) => {
                    commit(apisTypes.REMOVE_OPTIONAL_SCOPE_FAILURE, error)
                    reject(error)
                })
            })
        },
    }
}